module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_keshavarzian_sm-b2637b12d59dd71e5ff3ac38c51189b6.png";